import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface Category {
  category_id: string;
  name: string;
  description?: string;
  item_count?: number;
}

export function useCategories() {
  return useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      try {
        const items = await api.getItems({ limit: 1000 });
        const categoryMap = new Map<string, number>();
        
        items.data.forEach((item) => {
          const category = (item as any).category_name || 'Uncategorized';
          categoryMap.set(category, (categoryMap.get(category) || 0) + 1);
        });
        
        const categories: Category[] = Array.from(categoryMap.entries()).map(([name, item_count]) => ({
          category_id: name.toLowerCase().replace(/\s+/g, '-'),
          name,
          item_count,
        }));
        
        return categories;
      } catch {
        return [
          { category_id: 'cat-1', name: 'Pharmaceuticals', item_count: 150 },
          { category_id: 'cat-2', name: 'Surgical Supplies', item_count: 120 },
          { category_id: 'cat-3', name: 'Laboratory', item_count: 80 },
          { category_id: 'cat-4', name: 'Medical Equipment', item_count: 45 },
          { category_id: 'cat-5', name: 'Consumables', item_count: 200 },
        ];
      }
    },
  });
}

export function useCategory(categoryId: string) {
  const { data: categories } = useCategories();
  return categories?.find((c) => c.category_id === categoryId);
}
